"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DSTL001DetailTableStyled = exports.DSTL001DetailStyled = void 0;
const styled_components_1 = __importStar(require("styled-components"));
exports.DSTL001DetailStyled = styled_components_1.default.div `
	input:disabled {
		background: var(--color-white, #ffffff);
	}

	.box {
		min-height: 92px;
	}

	.dst001_detail_title {
		color: var(--color-black, #101010);
		text-align: left;
		font-family: var(--h3-font-family, 'Noto Sans KR', sans-serif);
	}

	.wrong-wrap {
		display: flex;
		flex-direction: ${props => (props.$isMobile || props.$isTablet ? 'column' : 'row')};
		gap: 12px;
	}

	.placeholder_wrap {
		border-radius: 4px;
		border-style: solid;
		border-color: var(--color-grey-w, #b6bac0);
		border-width: 1px;
		padding: 12px 10px 12px 10px;
		display: flex;
		flex-direction: row;
		gap: 10px;
		align-items: center;
		justify-content: flex-start;
		flex: 1;
		position: relative;
		p {
			white-space: break-spaces;
			color: var(--color-black, #101010);
			text-align: left;
			font-family: 'Noto Sans KR', sans-serif;
			font-size: 12px;
			line-height: 150%;
			letter-spacing: -0.02em;
			font-weight: 400;
			position: relative;
			align-self: stretch;
			flex: 1;
			word-break: break-all;
		}
	}

	.warp-001 {
		display: flex;
		flex-direction: row;
		gap: 47px;
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		flex: 1;
		position: relative;
		width: 100%;
		height: calc(100% - 103px);

		.test-info-container {
			border-radius: 10px;
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 1px;
			padding: 24px;
			display: flex;
			flex-direction: column;
			gap: 16px;
			align-items: flex-end;
			justify-content: flex-start;
			align-self: stretch;
			flex-shrink: 0;
			position: relative;
		}

		.value-container {
			display: flex;
			flex-direction: column;
			gap: 20px;
			align-items: flex-start;
			justify-content: flex-start;
			align-self: stretch;
			flex-shrink: 0;
			position: relative;
			flex: 1;

			._001,
			._001 * {
				box-sizing: border-box;
			}
			._001 {
				display: flex;
				flex-direction: row;
				gap: 16px;
				align-items: center;
				justify-content: flex-start;
				flex-shrink: 0;
				position: relative;
			}

			.submission_status_box {
				padding: 20px;
				display: flex;
				flex-direction: column;
				gap: 16px;
				box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.02);
				width: max-content;
				.submission_txt_wrap {
					display: flex;
					gap: 8px;
				}
			}
		}
	}

	.test-date-container {
		display: flex;
		flex-direction: column;
		gap: 12px;
		width: 100%;
	}

	.average-wrap {
		display: flex;
		flex-direction: row;
		gap: 39px;
		align-items: center;
		justify-content: flex-start;
	}

	.submission-name {
		-webkit-line-clamp: 1;
	}

	${props => (props.$isTablet ? tabletStyles : props.$isMobile ? mobileStyles : desktopStyles)}
`;
const mobileStyles = (0, styled_components_1.css) `
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	align-self: stretch;
	flex-shrink: 0;
	position: relative;
	height: 100%;
	width: 100%;

	.wrong-rate-list {
		display: flex;
		flex-direction: column;
		gap: 12px;
		width: 100%;
	}

	.item {
		border-style: solid;
		border-color: var(--color-silver, #f3f4f8);
		border-width: 1px 0px 0px 0px;
		padding: 12px 0px 12px 0px;
		display: flex;
		flex-direction: column;
		gap: 4px;
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;

		text-align: left;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 12px;
		line-height: 150%;
		letter-spacing: -0.02em;
		font-weight: 400;
		text-overflow: ellipsis;
		overflow: hidden;
	}

	.tab-item {
		display: flex;
		flex-direction: column;
		gap: 12px;
		width: 100%;
		height: 100%;

		.submission-title {
			text-align: left;
			font-family: 'Noto Sans KR', sans-serif;
			font-size: 18px;
			line-height: 150%;
			letter-spacing: -0.02em;
			font-weight: 700;
			position: relative;
			align-self: stretch;
			display: flex;
			align-items: center;
			justify-content: flex-start;
		}

		.task-label {
			.overText {
				text-align: left;
				font-family: 'Noto Sans KR', sans-serif;
				font-size: 18px;
				line-height: 150%;
				letter-spacing: -0.02em;
				font-weight: 700;
				position: relative;
				align-self: stretch;
				display: flex;
				align-items: center;
				justify-content: flex-start;
			}
		}

		.more_txt,
		.overText {
		}

		.bold {
			font-size: 14px;
			line-height: 150%;
			letter-spacing: -0.02em;
			font-weight: 700;
		}

		.contents {
			gap: 12px;
			.answer {
				width: 48%;
				overflow: hidden;
			}
		}
	}

	.dst001_detail_title {
		font-size: var(--h3-font-size, 20px);
		line-height: 150%;
		letter-spacing: -0.02em;
		font-weight: var(--h3-font-weight, 700);
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}

	.box {
		min-height: 48px;
	}

	.errorate-box {
		overflow: auto;
	}

	.score-wrap {
		display: flex;
		gap: 4px;
	}

	.divider {
		background: var(--color-silver, #f3f4f8);
		width: 1px;
		position: relative;
	}

	.average-wrap {
		display: flex;
		flex-direction: column;	
		width: 100%;
	}

	.average-container {
		width: 100%;
	}

	.mobile-tab-layout {
		.task-label {
			min-width: 65px;
		}
	}
`;
const tabletStyles = (0, styled_components_1.css) `
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;

	.hr {
		background: var(--color-silver, #f3f4f8);
		align-self: stretch;
		min-height: 20px;
		height: 20px;
	}

	.test-info-container {
		display: flex;
		flex-direction: column;
		gap: 12px;
		padding: 20px;
	}

	.wrong-rate-list {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		gap: 24px;
		align-items: center;
		justify-content: center;
	}

	.no-rate-wrap {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: center;
		justify-content: center;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
		width: 100%;
		height: 100%;
		overflow: hidden;
		flex: 1;
	}

	.average-wrap {
		display: flex;
		flex-direction: row;
		gap: 24px;
		align-items: center;
		justify-content: flex-start;
	}

	.dst001_detail_title {
		font-size: var(--h3-font-size, 20px);
		line-height: 150%;
		font-weight: var(--h3-font-weight, 700);
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}

	.task-info-wrap {
		display: flex;
		flex-direction: column;
		gap: 12px;
		padding: 20px;

		.box {
			min-height: 48px !important;
			button {
				p {
					font-size: 12px;
				}
			}
			svg {
				width: 14px;
				height: 14px;
			}
		}
	}

	.test-date-container {
		display: flex;
		flex-direction: row;
		gap: 24px;
	}

	.value-container {
		display: flex;
		flex-direction: column;
		padding: 20px;
		gap: 16px;
	}

	.error-rate-box {
		display: flex;
		flex-direction: row;
		gap: 24px;
		padding: 0px 0px 20px 0px;
	}

	.date-input-wrap {
		display: flex;
		flex-direction: row;
		gap: 12px;
		/* 
		.field-global-001 {
			.task-label {
				min-width: unset;
			}
		} */
	}

	.assignment-info {
		width: 100%;
		padding: 0px;
		flex-direction: row;

		.field-short {
			width: unset;
			flex: 1;
		}
	}

	.box {
		min-height: 48px !important;
	}

	.paging {
		position: relative;
	}
`;
const desktopStyles = (0, styled_components_1.css) `
	display: flex;
	gap: 20px;
	flex-direction: column;
	width: 100%;

	.wrong-rate-list {
		padding: 12px 0px 0px 0px;
		display: flex;
		flex-direction: row;
		gap: 39px;
		align-items: flex-start;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
		width: 100%;
		flex: 1;
	}

	.no-rate-wrap {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: center;
		justify-content: center;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
		width: 100%;
		height: 100%;
		overflow: hidden;
		flex: 1;
	}

	.dst001_detail_title {
		font-size: var(--h3-font-size, 24px);
		line-height: var(--h3-line-height, 36px);
		font-weight: var(--h3-font-weight, 700);
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}

	.error-rate-box {
		display: flex;
		flex-direction: row;
		padding: 0px 0px 20px 0px;
	}

	.test-info-container {
		width: 100%;
		max-width: 40%;
		min-width: 600px;
	}
`;
exports.DSTL001DetailTableStyled = styled_components_1.default.div `
	flex: 1; //PC 테스트 제출 상세보기 - 제출내역 없을 때

	.detail_txt {
		color: var(--color-grey, #666666);
		text-align: left;
		font-family: 'Noto Sans KR', sans-serif;
		text-decoration: underline;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		cursor: pointer;
	}

	.more_txt {
		color: var(--color-black, #101010);
		text-decoration: underline;
		cursor: pointer;
	}

	.detail_more_txt {
		color: var(--color-pink, #f46790);
		text-decoration: underline;
		cursor: pointer;

		&_bold {
			color: var(--color-pink, #f46790);
			text-decoration: underline;
			cursor: pointer;
			font-weight: 700;
			font-family: 'Noto Sans KR', sans-serif;
		}
	}

	.task-list-popup,
	.task-list-002 {
		width: 100%;
	}

	.underline {
		color: #3ab2bf;
		text-decoration: underline;
	}

	.empty_data {
		height: 100px;
	}

	${props => props.$isMobile || props.$isTablet
    ? mobileTablestyles
    : desktopTableStyles}
`;
const mobileTablestyles = (0, styled_components_1.css) `
	flex: 1;
	&.detail_table:not(&.popup-table) {
		flex: 1;
	}

	.detail_txt {
		font-size: 14px;
		line-height: 150%;
		letter-spacing: -0.02em;
		font-weight: 400;
	}

	.task-label {
		flex-direction: row;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.task-list-mobile {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		flex: 1;
		min-height: 240px;
		position: relative;

		.item {
			padding: 12px 0px 20px 0px;
			display: flex;
			flex-direction: column;
			gap: 12px;
			align-items: flex-start;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;
			width: 100%;

			.body-item {
				color: var(--color-black, #101010);
				text-align: left;
				font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
				font-size: var(--b4-font-size, 14px);
				line-height: var(--b4-line-height, 28px);
				font-weight: var(--b4-font-weight, 400);
				align-items: flex-start;
				justify-content: flex-start;
				width: 100%;
			}
		}

		.error-info-wrap {
			display: flex;
			flex-direction: row;
			gap: 4px;
			align-items: center;
			justify-content: flex-start;
			align-self: stretch;
			flex-shrink: 0;
			position: relative;
			width: 100%;
		}

		.rankings {
			color: var(--color-black, #101010);
			text-align: left;
			font-family: 'Noto Sans KR', sans-serif;
			font-size: 12px;
			line-height: 150%;
			letter-spacing: -0.02em;
			font-weight: 700;
			position: relative;
			width: 30px;
			display: flex;
			align-items: center;
			justify-content: flex-start;
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
		}

		.error-frame {
			display: flex;
			flex-direction: row;
			gap: 4px;
			align-items: center;
			justify-content: flex-start;
			flex: 1;
			position: relative;
		}

		.error-rate-text {
			color: var(--color-grey-l, #83868a);
			text-align: left;
			font-family: 'Noto Sans KR', sans-serif;
			font-size: 12px;
			line-height: 150%;
			letter-spacing: -0.02em;
			font-weight: 700;
			position: relative;
			display: flex;
			align-items: center;
			justify-content: flex-start;
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
		}

		.ratio {
			background: var(--color-silver, #f3f4f8);
			border-radius: 8px;
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 1px 0px 0px 0px;
			padding: 12px 10px 12px 10px;
			display: flex;
			flex-direction: row;
			gap: 4px;
			align-items: center;
			justify-content: flex-start;
			align-self: stretch;
			flex-shrink: 0;
			position: relative;
			width: 100%;
		}

		.choice-ratio-text {
			color: var(--color-black, #101010);
			text-align: left;
			font-family: 'Noto Sans KR', sans-serif;
			font-size: 10px;
			line-height: 150%;
			letter-spacing: -0.02em;
			font-weight: 400;
			position: relative;
			width: 42px;
		}

		.choice-ratio-index {
			color: var(--color-grey-l, #83868a);
			text-align: left;
			font-family: 'Noto Sans KR', sans-serif;
			font-size: 12px;
			line-height: 150%;
			letter-spacing: -0.02em;
			font-weight: 400;
			position: relative;
			display: flex;
			align-items: center;
			justify-content: center;
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
		}
	}

	.task-list-mobile-popup {
		.item {
			gap: 4px;
			padding: 0px 0px 20px 0px;
		}
	}

	.task-list-002 {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		flex: 1;
		min-height: 240px;
		position: relative;

		.table-header {
			background: var(--color-silver, #f3f4f8);
			border-style: solid;
			border-color: var(--color-grey-w, #b6bac0);
			border-width: 1px 0px 0px 0px;
			padding: 10px 16px 10px 16px;
			display: flex;
			flex-direction: row;
			gap: 20px;
			align-items: flex-start;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;
			width: 100%;
		}

		.item {
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 0px 0px 1px 0px;
			padding: 10px 16px 10px 16px;
			display: flex;
			flex-direction: row;
			gap: 20px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;

			.body-item {
				color: var(--color-black, #101010);
				text-align: left;
				font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
				font-size: var(--b4-font-size, 14px);
				line-height: var(--b4-line-height, 28px);
				font-weight: var(--b4-font-weight, 400);
				position: relative;
				width: 20px;
				display: flex;
				align-items: center;
				justify-content: flex-start;
				text-overflow: ellipsis;
				overflow: hidden;
				white-space: nowrap;
			}
		}
	}

	${props => props.$isDetail
    ? (0, styled_components_1.css) `
					&.detail_table:not(&.popup-table) {
						flex: 1;
					}
					.task-label {
						flex-direction: row;
						display: flex;
						justify-content: space-between;
						align-items: center;

						color: var(--color-black, #101010);
						text-align: left;
						font-family: var(--h4-font-family, 'Noto Sans KR', sans-serif);
						font-size: 16px;
						line-height: 28px;
						letter-spacing: var(--h4-letter-spacing, -0.02em);
						font-weight: var(--h4-font-weight, 700);
						position: relative;
					}
					.task-list-popup,
					.task-list-002 {
						display: flex;
						flex-direction: column;
						gap: 0px;
						align-items: flex-start;
						justify-content: flex-start;
						flex: 1;
						min-height: 240px;
						position: relative;

						.scroll-content {
							border-style: solid;
							border-color: var(--color-grey-w, #b6bac0);
							border-width: 1px 0px 0px 0px;
							display: flex;
							flex-direction: column;
							gap: 0px;
							align-items: flex-start;
							justify-content: flex-start;
							align-self: stretch;
							flex: 1;
							position: relative;
						}
							.item {
							border-style: solid;
							border-color: var(--color-silver, #f3f4f8);
							border-width: 0px 0px 1px 0px;
								padding: 12px 0px 16px 0px;
							display: flex;
							flex-direction: column;
							align-items: flex-start;
							justify-content: flex-start;
							align-self: stretch;
							flex-shrink: 0;
							position: relative;

							.body-item {
								text-align: left;
								font-family: 'Noto Sans KR', sans-serif;
									font-size: 13px;
								line-height: 150%;
								letter-spacing: -0.02em;
								font-weight: 400;
								position: relative;
								display: flex;
								overflow: visible;
								white-space: normal;
								align-items: flex-start;
								justify-content: flex-start;
								text-overflow: unset;
									gap: 8px;
									flex-direction: column;
									width: 100%;

									&.tablet-row {
										flex-direction: row;
										align-items: center;
										justify-content: space-between;
										gap: 12px;

										.mobile-action-row {
											width: auto;
											flex-shrink: 0;
										}
									}

									.mobile-detail-info {
										flex: 1;
										min-width: 0;
										display: flex;
										flex-direction: column;
										gap: 4px;
									}
								}
						}
					}

					.mobile-detail-item {
						width: 100%;
					}

					.mobile-detail-header {
						display: flex;
						flex-direction: row;
						align-items: center;
						gap: 10px;
						width: 100%;
					}

					.mobile-status-chip-wrap {
						width: 50px;
						display: inline-flex;
						justify-content: flex-start;
						flex-shrink: 0;
					}

					.mobile-status-chip {
						border: 1px solid var(--color-grey-w, #b6bac0);
						border-radius: 6px;
						padding: 2px 8px;
						color: var(--color-black, #101010);
						font-size: 12px;
						font-weight: 700;
						line-height: 150%;
						white-space: nowrap;
					}

					.mobile-status-chip.not-submitted {
						background: var(--color-silver, #f3f4f8);
					}

					.mobile-member-name {
						color: var(--color-black, #101010);
						font-size: 14px;
						font-weight: 400;
						line-height: 150%;
					}

					.mobile-member-name-strong {
						font-weight: 700;
					}

					.mobile-score-line {
						color: var(--color-grey-l, #83868a);
						font-size: 12px;
						font-weight: 400;
						line-height: 150%;
					}

					.mobile-action-row {
						display: flex;
						flex-direction: row;
						gap: 6px;
						width: 100%;
						justify-content: ${({ $isTablet }) => ($isTablet ? 'flex-end' : 'flex-start')};
					}

					.mobile-action-btn {
						flex: ${({ $isTablet }) => ($isTablet ? '0 0 120px' : '1')};
						min-width: 0;
						height: 34px;
						border: none;
						border-radius: 8px;
						background: #666666;
						color: #ffffff;
						font-family: 'Noto Sans KR', sans-serif;
						font-size: 11px;
						font-weight: 400;
						line-height: 150%;
						cursor: pointer;
						padding: 0 8px;

						p {
							font-size: 11px;
							font-weight: 400;
							min-width: 0;
							top: 0;
						}
					}

					.student-info-wrap {
						display: flex;
						flex-direction: row;
						gap: 4px;
						align-items: center;
						justify-content: flex-start;
						align-self: stretch;
						flex-shrink: 0;
						position: relative;
					}

					.score-info-wrap {
						display: flex;
						flex-direction: row;
						gap: 4px;
						align-items: center;
						justify-content: flex-start;
						flex-shrink: 0;
						position: relative;
						width: 100%;
					}

					.tur {
						color: var(--tur, #3ab2bf);
						text-align: left;
						font-family: 'Noto Sans KR', sans-serif;
						font-size: 12px;
						line-height: 150%;
						letter-spacing: -0.02em;
						font-weight: 700;
						text-decoration: underline;
					}

					.score-bold {
						font-weight: 700;
					}
			  `
    : (0, styled_components_1.css) ``}
`;
const desktopTableStyles = (0, styled_components_1.css) `
	&.detail_table:not(&.popup-table) {
		flex: 1;
		min-height: 300px;
		min-width: 550px;
	}

	.detail_txt {
		font-size: 16px;
		font-weight: 400;
	}

	.task-label {
		flex-direction: row;
		display: flex;
		justify-content: space-between;
		align-items: center;

		color: var(--color-black, #101010);
		text-align: left;
		font-family: var(--h4-font-family, 'Noto Sans KR', sans-serif);
		font-size: var(--h4-font-size, 18px);
		line-height: var(--h4-line-height, 32px);
		letter-spacing: var(--h4-letter-spacing, -0.02em);
		font-weight: var(--h4-font-weight, 700);
		position: relative;
	}

	.task-list-popup,
	.task-list-002 {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		flex: 1;
		min-height: 240px;
		position: relative;

		.table-header {
			background: var(--color-silver, #f3f4f8);
			border-style: solid;
			border-color: var(--color-grey-w, #b6bac0);
			border-width: 1px 0px 0px 0px;
			padding: 10px 16px 10px 16px;
			display: flex;
			flex-direction: row;
			gap: 20px;
			align-items: flex-start;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;
			width: 100%;
		}

		.item {
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 0px 0px 1px 0px;
			padding: 10px 16px 10px 16px;
			display: flex;
			flex-direction: row;
			gap: 20px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;

			.body-item {
				color: var(--color-black, #101010);
				text-align: left;
				font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
				font-size: var(--b4-font-size, 14px);
				line-height: var(--b4-line-height, 28px);
				font-weight: var(--b4-font-weight, 400);
				position: relative;
				width: 20px;
				display: flex;
				align-items: center;
				justify-content: flex-start;
				text-overflow: ellipsis;
				overflow: hidden;
				white-space: nowrap;
			}
		}
	}
`;
